import styled from 'styled-components';

export const GreenBigDot = styled.div`
  width: 20px;
  height: 20px;
  background-color: var(--green);
  border-radius: 100%;
  margin-right: 10px;
`;
